import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsX } from "react-icons/bs";
import { FaMicrophone, FaVolumeUp } from "react-icons/fa";

const getSoundDeviceLabel = (info) => {
    if (!info || !info.label) return "";

    if (info.deviceId === "default" || info.deviceId === "communications") {
        // 20260916 시스템 기본 장치 식별자와 실제 장치명을 구분해 표시한다.
        return `${info.deviceId} · ${info.label.replace(/^(default|communications)\s*/i, "")}`;
    }

    return info.label;
}

const SoundDeviceChoice = ({ isPentalkAudioMixer, isMyMicEchoEnable, myMicInfo, teampUpSpeakerInfo, handsUpSpeakerInfo, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [lMySubMicVol, setMySubMicVol] = useState(myMicInfo.volume);
    const [lPartnerSpeakerVol, setPartnerSpeakerVol] = useState(teampUpSpeakerInfo.volume);
    const [lHandsupPartnerSpeakerVol, setHandsupPartnerSpeakerVol] = useState(handsUpSpeakerInfo.volume);
    const [lMyMicEchoEnable, setMyMicEchoEnable] = useState(isMyMicEchoEnable);

    useEffect(() => {
        setMySubMicVol(myMicInfo.volume);
    }, [myMicInfo.volume]);

    useEffect(() => {
        setPartnerSpeakerVol(teampUpSpeakerInfo.volume);
    }, [teampUpSpeakerInfo.volume]);

    useEffect(() => {
        setHandsupPartnerSpeakerVol(handsUpSpeakerInfo.volume);
    }, [handsUpSpeakerInfo.volume]);

    useEffect(() => {
        setMyMicEchoEnable(isMyMicEchoEnable);
    }, [isMyMicEchoEnable]);

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    const selectMySubMicDevice = (e) => {
        if (e.target.value !== -1) handleSelectedFunc({ selectedFunc: "SET_MY_SUB_MIC", kind: "DEVICE", value: e.target.value, idx: e.target.selectedIndex });
    }

    const selectTeamupSpeakerDevice = (e) => {
        if (e.target.value !== -1) handleSelectedFunc({ selectedFunc: "SET_PARTNER_SPEAKER", kind: "DEVICE", value: e.target.value, idx: e.target.selectedIndex });
    }

    const selectHandsupSpeakerDevice = (e) => {
        if (e.target.value !== -1) handleSelectedFunc({ selectedFunc: "SET_HANDSUP_PARTNER_SPEAKER", kind: "DEVICE", value: e.target.value, idx: e.target.selectedIndex });
    }

    const changeMySubMicVolume = (e) => {
        // setMySubMicVol(e.target.value);
        handleSelectedFunc({ selectedFunc: "SET_MY_SUB_MIC", kind: "VOLUME", value: e.target.value });
    }

    const changedPartnerSpeakerVolume = (e) => {
        // setPartnerSpeakerVol(e.target.value);
        handleSelectedFunc({ selectedFunc: "SET_PARTNER_SPEAKER", kind: "VOLUME", value: e.target.value });
    }

    const changedHandsupPartnerSpeakerVolume = (e) => {
        // setPartnerSpeakerVol(e.target.value);
        handleSelectedFunc({ selectedFunc: "SET_HANDSUP_PARTNER_SPEAKER", kind: "VOLUME", value: e.target.value });
    }

    const onChangeMyMicEcho = (e) => {
        handleSelectedFunc({ selectedFunc: "SET_MY_MIC_ECHO", value: e.target.checked });
    }

    return (
        <div className="hc-sound-device-choice" onClick={handlePreventClick}>
            <div className="title-area">
                <span>
                    <b>{t("음향_기기_설정", { ns: "hiclasstv" })}</b>
                </span>
                <span className="func-btn" style={{ position: 'absolute', right: '0' }} title={t("닫기", { ns: "common" })} onClick={() => handleSelectedFunc({ selectedFunc: "NONE" })}>
                    <BsX />
                </span>
            </div>
            <div className="list-group" style={{ overflow: 'auto' }}>
                <div className="d-flex flex-column list-group-hitem list-group-hitem-action m-0 p-2" style={{ height: 'initial', fontSize: '0.9rem' }}>
                    <div className="d-flex justify-content-between">
                        <span className="font-weight-bold grey-text">{t("음향_기기_설정_문구_1", { ns: "hiclasstv" })}</span>
                    </div>
                    {
                        !isPentalkAudioMixer ? 
                        <>
                            <select
                                className="custom-select small my-1"
                                style={{ width: 'initial', fontSize: '0.9rem' }}
                                value={myMicInfo && myMicInfo.list_mic && myMicInfo.list_mic.length > 0 ? myMicInfo.list_mic[myMicInfo.selectedIndex].deviceId : ""}
                                onChange={selectMySubMicDevice}>
                                {
                                    myMicInfo && myMicInfo.list_mic && myMicInfo.list_mic.length > 0 ?
                                        myMicInfo.list_mic.map((info, index) => (
                                            <option value={info.deviceId} key={"mySubMic-" + index}>{getSoundDeviceLabel(info)}</option>
                                        )) :
                                        <option value="-1">{t("음향_기기_설정_문구_2", { ns: "hiclasstv" })}</option>
                                }
                            </select>
                            <div className="d-flex align-items-center grey-text">
                                <FaMicrophone className="font-md mr-2" />
                                <input type="range" className="custom-range w-75" id="mySubMicSlider" min="0" max="100" defaultValue={lMySubMicVol} onChange={changeMySubMicVolume} disabled={myMicInfo && myMicInfo.list_mic && myMicInfo.list_mic.length <= 0} />
                                <label htmlFor="mySubMicSlider" className="m-0 mx-2"><b>{lMySubMicVol}</b></label>
                            </div>
                            <div className="d-flex align-items-end justify-content-end mt-1 grey-text">
                                <span>{t("음향_기기_설정_문구_3", { ns: "hiclasstv" })}</span>
                                <div className="custom-control custom-switch ml-2">
                                    <input type="checkbox" className="custom-control-input" id="customSwitch" checked={lMyMicEchoEnable} onChange={onChangeMyMicEcho} />
                                    <label className="custom-control-label" htmlFor="customSwitch">&nbsp;</label>
                                </div>
                            </div>
                        </> :
                        <div style={{ padding: '.25rem 0 0' }}>
                            <span style={{ fontWeight: 'bold', color: 'rgb(40, 116, 255)' }}>
                                Pentalk Audio Mixer 사용 중..
                            </span>
                        </div>
                    }
                </div>
                <div className="d-flex flex-column list-group-hitem list-group-hitem-action m-0 p-2" style={{ height: 'initial', fontSize: '0.9rem' }}>
                    <span className="font-weight-bold grey-text">{t("음향_기기_설정_문구_4", { ns: "hiclasstv" })}</span>
                    <select
                        className="custom-select small my-1"
                        style={{ width: 'initial', fontSize: '0.9rem' }}
                        value={teampUpSpeakerInfo && teampUpSpeakerInfo.list_speaker && teampUpSpeakerInfo.list_speaker.length > 0 ? teampUpSpeakerInfo.list_speaker[teampUpSpeakerInfo.selectedIndex].deviceId : ""}
                        onChange={selectTeamupSpeakerDevice}>
                        {
                            teampUpSpeakerInfo && teampUpSpeakerInfo.list_speaker && teampUpSpeakerInfo.list_speaker.length > 0 ?
                                teampUpSpeakerInfo.list_speaker.map((info, index) => (
                                    <option value={info.deviceId} key={"partnerSpeaker-" + index}>{getSoundDeviceLabel(info)}</option>
                                )) :
                                <option value="-1">{t("음향_기기_설정_문구_2", { ns: "hiclasstv" })}</option>
                        }
                    </select>
                    <div className="d-flex align-items-center grey-text">
                        <FaVolumeUp className="font-md mr-2" />
                        <input type="range" className="custom-range w-75" id="teamupSpeakerSlider" min="0" max="100" defaultValue={lPartnerSpeakerVol} onChange={changedPartnerSpeakerVolume} disabled={teampUpSpeakerInfo && teampUpSpeakerInfo.list_speaker && teampUpSpeakerInfo.list_speaker.length <= 0} />
                        <label htmlFor="teamupSpeakerSlider" className="m-0 mx-2"><b>{lPartnerSpeakerVol}</b></label>
                    </div>
                </div>
                <div className="d-flex flex-column list-group-hitem list-group-hitem-action m-0 p-2" style={{ height: 'initial', fontSize: '0.9rem' }}>
                    <span className="font-weight-bold grey-text">{t("음향_기기_설정_문구_5", { ns: "hiclasstv" })}</span>
                    <select
                        className="custom-select small my-1"
                        style={{ width: 'initial', fontSize: '0.9rem' }}
                        value={handsUpSpeakerInfo && handsUpSpeakerInfo.list_speaker && handsUpSpeakerInfo.list_speaker.length > 0 ? handsUpSpeakerInfo.list_speaker[handsUpSpeakerInfo.selectedIndex].deviceId : ""}
                        onChange={selectHandsupSpeakerDevice}>
                        {
                            handsUpSpeakerInfo && handsUpSpeakerInfo.list_speaker && handsUpSpeakerInfo.list_speaker.length > 0 ?
                                handsUpSpeakerInfo.list_speaker.map((info, index) => (
                                    <option value={info.deviceId} key={"handsupPartnerSpeaker-" + index}>{getSoundDeviceLabel(info)}</option>
                                )) :
                                <option value="-1">{t("음향_기기_설정_문구_2", { ns: "hiclasstv" })}</option>
                        }
                    </select>
                    <div className="d-flex align-items-center grey-text">
                        <FaVolumeUp className="font-md mr-2" />
                        <input type="range" className="custom-range w-75" id="handsupSpeakerSlider" min="0" max="100" defaultValue={lHandsupPartnerSpeakerVol} onChange={changedHandsupPartnerSpeakerVolume} disabled={handsUpSpeakerInfo && handsUpSpeakerInfo.list_speaker && handsUpSpeakerInfo.list_speaker.length <= 0} />
                        <label htmlFor="handsupSpeakerSlider" className="m-0 mx-2"><b>{lHandsupPartnerSpeakerVol}</b></label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SoundDeviceChoice;
